var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0465 4.45312C20.3452 4.45312 16.9904 6.63083 15.4836 10.0114L9.38656 23.6906C5.73148 23.9418 2.84375 26.9843 2.84375 30.7031V36.0938C2.84375 39.3298 5.46711 41.9531 8.70312 41.9531H10.3092C10.3179 41.5022 10.3293 41.0514 10.3438 40.6005C9.9623 39.823 9.74727 38.949 9.74727 38.0245L9.64062 33.8672C9.64062 30.7927 10.2662 29.6094 12.5483 29.1497C13.6331 28.9311 14.5413 28.192 14.9858 27.1786L22.5148 10.0114C24.0215 6.63083 27.3764 4.45312 31.0777 4.45312H24.0465Z",
    fill: "#EEF1FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70312 41.9531C5.46711 41.9531 2.84375 39.3298 2.84375 36.0938V30.7031C2.84375 26.9843 5.73148 23.9418 9.38656 23.6906L15.4836 10.0114C16.9903 6.63083 20.3451 4.45312 24.0465 4.45312H34.7217C38.2441 4.45312 41.4692 6.4275 43.0711 9.56461L46.0859 15.4688M58.1562 30.7031C58.1562 26.8199 55.0082 23.6719 51.125 23.6719H19.1328M28.7422 15.4688V4.57031M32.9609 41.9531H27.6873M21.242 37.2656C18.6532 37.2656 16.5545 39.3643 16.5545 41.9531C16.5545 44.5419 18.6532 46.6406 21.242 46.6406C23.8307 46.6406 25.9295 44.5419 25.9295 41.9531C25.9295 39.3643 23.8309 37.2656 21.242 37.2656Z",
    stroke: "#405FF2",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1562 41.6016C58.1562 46.0997 54.5097 49.8047 50.0117 49.8047C45.5136 49.8047 41.8671 46.1583 41.8671 41.6602C41.8671 37.162 45.5722 33.5156 50.0703 33.5156M44.0351 48.1055L36.5938 55.5469",
    stroke: "#FF5CF3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.361a47df28c5bd1a37de786ca14202af.svg";
export { ForwardRef as ReactComponent };